const newBadgesReducer = (
  state = {
    intervention_id: 0,
    badges: []
  },
  action
) => {
  switch (action.type) {
    case "SET_NEW_BADGES":
      return {
        intervention_id: action.payload.intervention_id,
        badges: action.payload.badges,
      };
    default:
      return state;
  }
};

export default newBadgesReducer;
